import React from 'react'
import { StandardOpenModalButton } from 'src/components/ModalForms/ModalButtons'
import { ModalFormId } from '../../../../components/ModalForms'
import { ChooseFrameworkModal } from '../../../../components/ModalForms/Frameworks'
import { FlexButtonGroup } from '../../../../components/Reusable/Buttons/FlexButtonGroup'
import { ImportControlsButton } from '../../../../components/Reusable/Buttons/ImportControlsButton'
import {
  StandardButtonSize,
  StandardButtonVariant,
} from '../../../../components/Reusable/Buttons/StandardButton'

export const NoControlsButtonGroup = ({
  isAdmin,
  hasOpenAudits,
}: {
  isAdmin: boolean
  hasOpenAudits: boolean
}): JSX.Element => {
  return (
    <>
      <ChooseFrameworkModal />
      <FlexButtonGroup num={3}>
        <StandardOpenModalButton
          variant={StandardButtonVariant.PRIMARY}
          size={StandardButtonSize.MEDIUM}
          modalId={ModalFormId.CHOOSE_COMPLIANCE_FRAMEWORK}
          text="Add Compliance Framework"
        />
        <ImportControlsButton
          id={'import-controls-empty'}
          variant={StandardButtonVariant.SECONDARY}
          size={StandardButtonSize.MEDIUM}
          hasOpenAudits={hasOpenAudits}
          isAdmin={isAdmin}
          fromEmpty
        />
        <StandardOpenModalButton
          variant={StandardButtonVariant.SECONDARY}
          size={StandardButtonSize.MEDIUM}
          modalId={ModalFormId.ADD_CONTROL_OPTIONS}
          text="Add Control Manually"
        />
      </FlexButtonGroup>
    </>
  )
}
